import { getRequest, postRequest } from ".";

export const accountSetupStatus = () => {
  return getRequest('/user/account-setup-status');
};

export const getPresignedUrlOfUserProfile = (payload) => {
  return postRequest('/user/profile-image-upload', payload);
}

export const getImageUrlOfUserProfile = () => {
  return getRequest('/user/get-profile-image-url');
}